import React from "react";
import { Helmet } from "react-helmet";
import ContactUsImage from "./Component/ContactUsImage/ContactUsImage";
import ContactUsInfo from "./Component/ContactUsInfo/ContactUsInfo";
import Footer from "../../components/Footer/footer";
import ContactUsMap from "./Component/ContactUsMap/ContactUsMap";

const ContactUs = () => {
  return (
    <>
      <Helmet>
        <title>Contact BA Code Solutions | Web Developer in Ahmedabad</title>

        <meta
          name="description"
          content="Contact BA Code Solutions, a web development company in Ahmedabad. Hire expert React developers for your website or business project."
        />

        <meta
          name="keywords"
          content="contact web developer Ahmedabad, hire react developer India, web development contact, BA Code Solutions"
        />

        <meta name="robots" content="index, follow" />

        {/* Open Graph */}
        <meta property="og:title" content="Contact BA Code Solutions" />
        <meta
          property="og:description"
          content="Get in touch with BA Code Solutions for professional web development services."
        />
        <meta property="og:type" content="website" />
        <meta       
          property="og:url"
          content="https://bacodesolutions.com/contact-us"
        />
        <meta
          property="og:image"
          content="https://bacodesolutions.com/logo192.png"
        />
      </Helmet>
      <ContactUsImage />
      <ContactUsInfo />
      <ContactUsMap />
      <Footer />
    </>
  );
};

export default ContactUs;
